/**
 * Ελαφρύ "bus" για το άνοιγμα του παιχνιδιού.
 *
 * Το `PandaGameModal` φορτώνει όλα τα παιχνίδια + supabase + server functions.
 * Όποιος έκανε import το `openPandaGame` από εκεί (π.χ. το Header) τραβούσε
 * ολόκληρο αυτό το JS στο αρχικό bundle. Εδώ μένει μόνο το event.
 */
export const OPEN_GAME_EVENT = "mrpanda:open-game";

/**
 * Το modal μπορεί να μην έχει προλάβει να γίνει mount όταν πατηθεί το κουμπί
 * (φορτώνεται lazy μετά την πρώτη αλληλεπίδραση), οπότε κρατάμε ένα pending
 * flag που διαβάζει μόλις εμφανιστεί.
 */
let pending = false;

export function openPandaGame() {
  if (typeof window === "undefined") return;
  pending = true;
  window.dispatchEvent(new CustomEvent(OPEN_GAME_EVENT));
}

export function consumePendingGameOpen(): boolean {
  const was = pending;
  pending = false;
  return was;
}
